import React from "react";
import { useLang } from "../i18n";
import { LegalLayout, LegalSection, LegalNote } from "../components/site/LegalLayout";

const CONTACT_EMAIL = "info@procurmo.com";

const de = {
  title: "Datenschutzerklärung",
  intro:
    "Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Nachfolgend informieren wir Sie gemäß der Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG) über die Verarbeitung Ihrer Daten auf dieser Website.",
  note:
    "Hinweis: Angaben in eckigen Klammern [ … ] sind Platzhalter und werden vor dem offiziellen Launch durch die finalen Unternehmens- und Dienstleisterdaten ersetzt.",
  updated: "Stand: " + new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" }),
  sections: [
    {
      heading: "1. Verantwortlicher",
      paragraphs: [
        "Verantwortlicher im Sinne des Art. 4 Nr. 7 DSGVO ist:",
        "[Firmenname] [Rechtsform]",
        "[Straße und Hausnummer], [PLZ Ort], Deutschland",
        `E-Mail: ${CONTACT_EMAIL}`,
      ],
    },
    {
      heading: "2. Ihre Betroffenenrechte",
      paragraphs: ["Sie können unter der oben genannten E-Mail-Adresse jederzeit folgende Rechte ausüben:"],
      list: [
        "Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO),",
        "Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO),",
        "Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),",
        "Einschränkung der Datenverarbeitung (Art. 18 DSGVO),",
        "Datenübertragbarkeit (Art. 20 DSGVO),",
        "Widerspruch gegen die Verarbeitung (Art. 21 DSGVO),",
        "Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO).",
      ],
    },
    {
      heading: "3. Beschwerderecht bei der Aufsichtsbehörde",
      paragraphs: [
        "Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren (Art. 77 DSGVO). Zuständig ist die Aufsichtsbehörde des Bundeslandes, in dem der Verantwortliche seinen Sitz hat.",
      ],
    },
    {
      heading: "4. Bereitstellung der Website und Server-Logfiles",
      paragraphs: [
        "Beim Aufruf unserer Website werden durch den Hosting-Anbieter automatisch Informationen in Server-Logfiles erfasst, die Ihr Browser übermittelt. Dies sind insbesondere: IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite/Datei, Browsertyp und -version, Betriebssystem und Referrer-URL.",
        "Die Verarbeitung erfolgt zur Gewährleistung eines störungsfreien Betriebs, der Sicherheit und Stabilität der Website. Rechtsgrundlage ist unser berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO. Die Logfiles werden aus Sicherheitsgründen für einen begrenzten Zeitraum gespeichert und anschließend gelöscht.",
        "Hosting-Anbieter (Auftragsverarbeiter): [Name und Anschrift des Hosting-Anbieters]. Mit dem Anbieter besteht ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO.",
      ],
    },
    {
      heading: "5. Early-Access-Warteliste (Kontaktformular)",
      paragraphs: [
        "Wenn Sie sich über das Formular für den Early Access anmelden, verarbeiten wir die von Ihnen angegebenen Daten, um Sie in unsere Warteliste aufzunehmen und Sie im Zusammenhang mit dem Produkt (z. B. für einen Demo-Termin oder Produkt-Updates) zu kontaktieren.",
        "Folgende Daten werden verarbeitet:",
      ],
      list: [
        "Name",
        "E-Mail-Adresse",
        "Unternehmen / Firma",
        "Unternehmenstyp",
        "Angaben zur Häufigkeit von Ausschreibungsteilnahmen (optional)",
        "aktuelle Herausforderung / Engpass (optional)",
        "gewählte Sprache und Zeitpunkt der Anmeldung",
      ],
    },
    {
      heading: "6. Rechtsgrundlage und Speicherdauer der Wartelisten-Daten",
      paragraphs: [
        "Rechtsgrundlage der Verarbeitung ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO sowie – soweit die Kontaktaufnahme der Anbahnung eines Vertragsverhältnisses dient – Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen).",
        "Ihre Daten werden gespeichert, bis der Zweck (Vorbereitung und Start des Produkts, Kontaktaufnahme) entfällt oder Sie Ihre Einwilligung widerrufen bzw. die Löschung verlangen. Sie können Ihre Einwilligung jederzeit formlos per E-Mail an " + CONTACT_EMAIL + " widerrufen. Der Widerruf berührt nicht die Rechtmäßigkeit der bis dahin erfolgten Verarbeitung.",
        "Die Daten werden in einer von uns betriebenen Datenbank gespeichert. Der Zugriff auf die Wartelisten-Daten ist auf berechtigte Personen beschränkt und passwortgeschützt.",
      ],
    },
    {
      heading: "7. Empfänger und Weitergabe von Daten",
      paragraphs: [
        "Eine Weitergabe Ihrer Daten an Dritte erfolgt nur, soweit dies zur Erfüllung des genannten Zwecks erforderlich ist, gesetzlich vorgeschrieben ist oder Sie eingewilligt haben. Technische Dienstleister (z. B. Hosting) verarbeiten Daten ausschließlich in unserem Auftrag auf Grundlage von Auftragsverarbeitungsverträgen (Art. 28 DSGVO).",
        "Eine Übermittlung in Länder außerhalb der EU/des EWR findet nur statt, wenn ein angemessenes Datenschutzniveau sichergestellt ist (z. B. Angemessenheitsbeschluss oder EU-Standardvertragsklauseln gemäß Art. 44 ff. DSGVO). [Sofern zutreffend: Angaben zum Drittlandtransfer ergänzen.]",
      ],
    },
    {
      heading: "8. Cookies und lokale Speicherung",
      paragraphs: [
        "Diese Website verwendet keine Tracking- oder Marketing-Cookies und bindet derzeit keine Analyse- oder Werbedienste Dritter ein.",
        "Zur Bereitstellung grundlegender Funktionen nutzen wir den lokalen Speicher (Local Storage) Ihres Browsers, um Ihre gewählte Spracheinstellung zu speichern. Diese Information verbleibt auf Ihrem Gerät und wird nicht an uns übertragen. Rechtsgrundlage für den Einsatz technisch notwendiger Speichertechnologien ist § 25 Abs. 2 TDDDG bzw. unser berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO.",
      ],
    },
    {
      heading: "9. Datensicherheit",
      paragraphs: [
        "Wir treffen technische und organisatorische Maßnahmen, um Ihre Daten gegen Verlust, Zerstörung, Manipulation und unbefugten Zugriff zu schützen. Die Übertragung erfolgt verschlüsselt über TLS/SSL (erkennbar am Schloss-Symbol bzw. \u201Ehttps://\u201C in der Adresszeile).",
      ],
    },
    {
      heading: "10. Keine automatisierte Entscheidungsfindung",
      paragraphs: [
        "Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne des Art. 22 DSGVO findet nicht statt.",
      ],
    },
    {
      heading: "11. Aktualität und Änderung dieser Datenschutzerklärung",
      paragraphs: [
        "Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung anzupassen. Die jeweils aktuelle Fassung kann jederzeit auf dieser Seite abgerufen werden.",
      ],
    },
  ],
};

const en = {
  title: "Privacy Policy",
  intro:
    "Protecting your personal data is important to us. Below we inform you, in accordance with the General Data Protection Regulation (GDPR) and the German Federal Data Protection Act (BDSG), about how we process your data on this website.",
  note:
    "Note: Items in square brackets [ … ] are placeholders and will be replaced with the final company and service-provider details before the official launch.",
  updated: "Last updated: " + new Date().toLocaleDateString("en-GB", { month: "long", year: "numeric" }),
  sections: [
    {
      heading: "1. Controller",
      paragraphs: [
        "The controller within the meaning of Art. 4(7) GDPR is:",
        "[Company name] [legal form]",
        "[Street and number], [Postal code, City], Germany",
        `Email: ${CONTACT_EMAIL}`,
      ],
    },
    {
      heading: "2. Your rights as a data subject",
      paragraphs: ["You may exercise the following rights at any time using the email address above:"],
      list: [
        "Right of access to your stored data and its processing (Art. 15 GDPR),",
        "Right to rectification of inaccurate personal data (Art. 16 GDPR),",
        "Right to erasure of your stored data (Art. 17 GDPR),",
        "Right to restriction of processing (Art. 18 GDPR),",
        "Right to data portability (Art. 20 GDPR),",
        "Right to object to processing (Art. 21 GDPR),",
        "Right to withdraw a given consent with effect for the future (Art. 7(3) GDPR).",
      ],
    },
    {
      heading: "3. Right to lodge a complaint",
      paragraphs: [
        "You also have the right to lodge a complaint with a data protection supervisory authority about our processing of your personal data (Art. 77 GDPR).",
      ],
    },
    {
      heading: "4. Provision of the website and server log files",
      paragraphs: [
        "When you access our website, the hosting provider automatically collects information in server log files transmitted by your browser, in particular: IP address, date and time of access, page/file requested, browser type and version, operating system and referrer URL.",
        "This processing serves to ensure trouble-free operation, security and stability of the website. The legal basis is our legitimate interest pursuant to Art. 6(1)(f) GDPR. Log files are stored for a limited period for security reasons and then deleted.",
        "Hosting provider (processor): [Name and address of hosting provider]. A data processing agreement pursuant to Art. 28 GDPR is in place.",
      ],
    },
    {
      heading: "5. Early-access waitlist (contact form)",
      paragraphs: [
        "When you sign up via the early-access form, we process the data you provide in order to add you to our waitlist and to contact you in connection with the product (e.g. for a demo appointment or product updates).",
        "The following data is processed:",
      ],
      list: [
        "Name",
        "Email address",
        "Company",
        "Type of company",
        "Frequency of tender participation (optional)",
        "Current challenge / bottleneck (optional)",
        "Selected language and time of registration",
      ],
    },
    {
      heading: "6. Legal basis and retention of waitlist data",
      paragraphs: [
        "The legal basis for the processing is your consent pursuant to Art. 6(1)(a) GDPR and – where the contact serves to initiate a contractual relationship – Art. 6(1)(b) GDPR (pre-contractual measures).",
        "Your data is stored until the purpose (preparation and launch of the product, contacting you) no longer applies or you withdraw your consent or request deletion. You can withdraw your consent at any time, informally, by email to " + CONTACT_EMAIL + ". Withdrawal does not affect the lawfulness of processing carried out up to that point.",
        "The data is stored in a database operated by us. Access to the waitlist data is limited to authorised persons and password-protected.",
      ],
    },
    {
      heading: "7. Recipients and data sharing",
      paragraphs: [
        "Your data is only shared with third parties where necessary to fulfil the stated purpose, legally required, or where you have consented. Technical service providers (e.g. hosting) process data exclusively on our behalf on the basis of data processing agreements (Art. 28 GDPR).",
        "Any transfer to countries outside the EU/EEA only takes place where an adequate level of data protection is ensured (e.g. adequacy decision or EU standard contractual clauses pursuant to Art. 44 et seq. GDPR). [If applicable: add details on third-country transfers.]",
      ],
    },
    {
      heading: "8. Cookies and local storage",
      paragraphs: [
        "This website does not use tracking or marketing cookies and currently does not integrate any third-party analytics or advertising services.",
        "To provide basic functionality, we use your browser's local storage to save your selected language preference. This information remains on your device and is not transmitted to us. The legal basis for the use of technically necessary storage technologies is Section 25(2) TDDDG and/or our legitimate interest pursuant to Art. 6(1)(f) GDPR.",
      ],
    },
    {
      heading: "9. Data security",
      paragraphs: [
        "We take technical and organisational measures to protect your data against loss, destruction, manipulation and unauthorised access. Transmission is encrypted via TLS/SSL (recognisable by the padlock icon or \u201Chttps://\u201D in the address bar).",
      ],
    },
    {
      heading: "10. No automated decision-making",
      paragraphs: ["No automated decision-making, including profiling within the meaning of Art. 22 GDPR, takes place."],
    },
    {
      heading: "11. Currency and changes to this privacy policy",
      paragraphs: [
        "This privacy policy is currently valid. As our website develops or due to changed legal or regulatory requirements, it may become necessary to amend this privacy policy. The current version can be accessed on this page at any time.",
      ],
    },
  ],
};

export default function Datenschutz() {
  const { lang } = useLang();
  const c = lang === "de" ? de : en;
  return (
    <LegalLayout title={c.title} intro={c.intro} updated={c.updated}>
      <LegalNote>{c.note}</LegalNote>
      {c.sections.map((s) => (
        <LegalSection key={s.heading} heading={s.heading} paragraphs={s.paragraphs} list={s.list} />
      ))}
    </LegalLayout>
  );
}
